import { FieldArray, useFormikContext } from 'formik';
import React, { useEffect } from 'react'
import FormikControl from '../../Components/HealthInsFormikComponent/FormikControl';
import CreateQuoteDependent from './Dependents/CreateQuoteDependent';
import CreateQuoteObjectView from './Dependents/CreateQuoteObjectView';
import _ from "lodash";


const ArrayMainComponent = ({ Fields, activeStep, depInd, quickQuoteDetails, formik, productName}) => {
    //console.log('hggg', Fields)
    const { values } = useFormikContext()

    useEffect(() => {
        
        if('nomineePercentClaim' in (values?.nomineeDetail?.[0] ?? {})){
            console.log('nom',values.nomineeDetail[0])
            console.log('dd',document.getElementById('nomineeDetail[0].nomineeNameTwo'))

            if (values.nomineeDetail[0].nomineePercentClaim < 100 && values.nomineeDetail[0].nomineePercentClaim != ''
             && Number(values.nomineeDetail[0].nomineePercentClaim) != 0) {
                
                 if(document.getElementById('nomineeDetail[0].nomineeNameTwo') !== null ){
                    document.getElementById('nomineeDetail[0].nomineeNameTwo').closest('.mb-3').removeAttribute('hidden')
                    document.getElementById('nomineeDetail[0].nomineeAgeTwo').closest('.mb-3').removeAttribute('hidden')
                    document.getElementById('nomineeDetail[0].nomineeRelationshipTwo').closest('div').closest('.mb-3').removeAttribute('hidden')
                    document.getElementById('nomineeDetail[0].nomineePercentClaimTwo').closest('.mb-3').removeAttribute('hidden')
                } 
               /*   */
                //setFieldValue('nomineeDetail[0].nomineePercentClaimTwo', percentageTwo )
            }
        }
    }, [values])
    

    return (
        <>
            <FieldArray
                name={Fields[activeStep].name}
                touched={formik.touched}
                render={(arrayHelpers) => {
                    //  console.log(depInd, "888", Fields[activeStep].name)
                    return (
                        <div>
                            {_.times(Fields[activeStep].name === "primaryDetail" || Fields[activeStep].name === "medicalQuestions"? depInd : 1, (i) => {
                                const objName = Fields[activeStep].name;
                                const arrObjName = `${objName}[${i}]`;
                                //  console.log("name...",objName,arrObjName)
                                return (
                                    <div key={i}>
                                        {
                                            Fields[activeStep].name === "primaryDetail" ?
                                                <><h3 className='text-capitalize'>primary detail  {i + 1}</h3></>
                                                : null
                                        }
                                        {
                                            Fields[activeStep].name === "medicalQuestions" ?
                                                <h3 className='text-capitalize'>medical questions  {i + 1}</h3>
                                                : null
                                        }
                                        {Fields[activeStep].obj.map(
                                            (field, index) => {
                                                return field.htmlElement ===
                                                    "TextField" ? (
                                                    <div
                                                        className="mb-3"
                                                        key={index}
                                                        hidden={field.hidden}
                                                    >
                                                        <FormikControl
                                                            control="input"
                                                            name={`${arrObjName}.${field.name}`}
                                                            /*  manualValidation={
                                                               field.manualValidation
                                                             } */
                                                            //errors={formik.errors}
                                                            readOnly={field.readOnly}
                                                            /*  transperData={
                                                               productDetails.transperData
                                                             }*/
                                                            url={field.url?.replace("http://65.0.70.70:82/", "https://backend.dev.acuvisor.com/")}
                                                            label={field.label}
                                                            type={field.dataType}
                                                            productName={productName}
                                                            arrayindex={i}
                                                        // touched={formik.touched}
                                                        />
                                                    </div>
                                                ) : field.htmlElement ===
                                                    "Select" ? (
                                                    <div
                                                        className="mb-3"
                                                        key={index}
                                                        hidden={field.hidden}
                                                    >
                                                        <FormikControl
                                                            control="select"
                                                            readOnly={field.readOnly}
                                                            arrayindex={i}
                                                            quickQuoteDetails={quickQuoteDetails}
                                                            name={`${arrObjName}.${field.name}`}
                                                            //errors={formik.errors}
                                                            label={field.label}
                                                            type={field.dataType}
                                                            //touched={formik.touched}
                                                            options={field.options}
                                                        />
                                                    </div>
                                                ) : field.htmlElement ===
                                                    "TextArea" ? (
                                                    <div
                                                        className="mb-3"
                                                        key={index}
                                                        hidden={field.hidden}
                                                    >
                                                        <FormikControl
                                                            control="textarea"
                                                            name={`${arrObjName}.${field.name}`}
                                                            //errors={formik.errors}
                                                            label={field.label}
                                                            type={field.dataType}
                                                        //touched={formik.touched}
                                                        />
                                                    </div>
                                                ) : field.htmlElement ===
                                                    "Radio" ? (
                                                    <div
                                                        className="mb-3"
                                                        key={index}
                                                        hidden={field.hidden}
                                                    >
                                                        <FormikControl
                                                            control="radio"
                                                            name={`${arrObjName}.${field.name}`}
                                                            //errors={formik.errors}
                                                            dependent={
                                                                field.dependent
                                                            }

                                                            options={field.options}
                                                            manualValidation={
                                                                field.manualValidation
                                                            }
                                                            arrayindex={i}
                                                            label={field.label}
                                                            type={field.dataType}
                                                        //touched={formik.touched}
                                                        />
                                                    </div>
                                                ) : field.htmlElement ===
                                                    "DatePicker" ? (
                                                    <div
                                                        className="mb-3"
                                                        key={index}
                                                        hidden={field.hidden}
                                                    >
                                                        <FormikControl
                                                            control="date"
                                                            name={`${arrObjName}.${field.name}`}
                                                            //errors={field.errors}
                                                            readOnly={field.readOnly}
                                                            arrayindex={i}
                                                            label={field.label}
                                                            type={field.dataType}
                                                            productName={productName}
                                                        />
                                                    </div>
                                                ) : field.htmlElement ===
                                                    "checkbox" ? (
                                                    <div
                                                        className="mb-3"
                                                        key={index}
                                                        hidden={field.hidden}
                                                    >
                                                        <FormikControl
                                                            control="checkBox"
                                                            name={`${arrObjName}.${field.name}`}
                                                            //errors={field.errors}
                                                            arrayindex={i}
                                                            label={field.label}
                                                            type={field.dataType}
                                                            options={field.options}
                                                        />
                                                    </div>
                                                )
                                                    : field.htmlElement === 'MultiSelect' ?
                                                        <div className="mb-3" key={index} hidden={field.hidden}>

                                                            <FormikControl
                                                                control='MultiSelect'
                                                                readOnly={field.readOnly}
                                                                name={field.name}
                                                                //errors={formik.errors}
                                                                label={field.label}
                                                                type={field.dataType}
                                                                //touched={formik.touched}
                                                                options={field.options}
                                                            //onChange={(e)=>onChange(e,field.name)}  
                                                            //onChange={(e) => formik.handleChange(e)}

                                                            />

                                                        </div>
                                                        : field.htmlElement ===
                                                            "Array" ? (
                                                            <div
                                                                className="mb-3"
                                                                key={index}
                                                                style={{
                                                                    marginTop: "24px",
                                                                }}
                                                            >
                                                                <h3 className="py-3 second-heading-text">
                                                                    {field.label}
                                                                </h3>
                                                                <div className="mb-3">
                                                                    <CreateQuoteDependent
                                                                        field={field}
                                                                        name={`${arrObjName}`}
                                                                        previousIndex={i}
                                                                        dependentIndex={1}
                                                                        quickQuoteDetails={quickQuoteDetails}

                                                                    /*  transperData={
                                                                       productDetails.transperData
                                                                     } */
                                                                    />
                                                                </div>
                                                            </div>
                                                        ) : field.htmlElement ===
                                                            "Object" ? (
                                                            <div
                                                                className="mb-3"
                                                                key={index}
                                                                style={{
                                                                    marginTop: "24px",
                                                                }}
                                                            >
                                                                <CreateQuoteObjectView
                                                                    data={field}
                                                                    quickQuoteDetails={quickQuoteDetails}
                                                                    previousObjectName={arrObjName}
                                                                    arrayindex={i}
                                                                />
                                                            </div>
                                                        ) : null;
                                            }
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    );
                }}
            ></FieldArray>
        </>

    )
}

export default ArrayMainComponent